export const BusEvents = {
    USER_MEMBERSHIP_UPDATE: 'USER_MEMBERSHIP_UPDATE'
};
